import { ReactElement } from "react";
import { HubItemMediaPreviewViewModel } from "client/Api/Hub/common";
import { HubItemCategoryModel } from "client/Api/Hub/hub";
import { PreviewItemUserModel } from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { ActiveFilter } from "client/Features/Hub/common";
import { HubCardItem } from "./HubCardItem/HubCardItem";
import { HubListItem } from "./HubListItem";
import { TagViewModel } from "client/Api/Tags/tags";
import { TimeZone } from "client/DateAndTime/timezones";

export type HubItemProps = {
	title: string;
	descriptionPreview: string | null;
	media: HubItemMediaPreviewViewModel;
	lastModifiedDate: Date | string;
	category: HubItemCategoryModel | undefined;
	numberOfViews: number;
	author: PreviewItemUserModel | null;
	tags: readonly TagViewModel[];
	onNavigate(): void;
	onActiveFilterChange(filter: ActiveFilter): void;
	onSelectedCategoryIdChange(selectedCategoryId: number | null): void;
	trackingId: string;
	isPinned: boolean;
	isMobile: boolean;
	timezone: TimeZone;
	isNew: boolean;
};

export const HubItem = (props: HubItemProps): ReactElement => {
	const {
		title,
		descriptionPreview,
		media,
		lastModifiedDate,
		category,
		numberOfViews,
		author,
		tags,
		onNavigate,
		onActiveFilterChange,
		onSelectedCategoryIdChange,
		trackingId,
		isPinned,
		isMobile,
		timezone,
		isNew
	} = props;

	return isMobile
		? (
			<HubListItem
				title={title}
				media={media}
				lastModifiedDate={lastModifiedDate}
				category={category}
				numberOfViews={numberOfViews}
				author={author}
				onNavigate={onNavigate}
				trackingId={trackingId}
				isPinned={isPinned}
				timezone={timezone}
				isNew={isNew}
			/>
		)
		: (
			<HubCardItem
				title={title}
				descriptionPreview={descriptionPreview}
				media={media}
				lastModifiedDate={lastModifiedDate}
				category={category}
				numberOfViews={numberOfViews}
				author={author}
				onNavigate={onNavigate}
				onActiveFilterChange={onActiveFilterChange}
				onSelectedCategoryIdChange={onSelectedCategoryIdChange}
				trackingId={trackingId}
				isPinned={isPinned}
				tags={tags}
				timezone={timezone}
				isNew={isNew}
			/>
		);
};

HubItem.displayName = "HubItem";